<template>
	<div class="project-calendar">
		<AppLazyLoaderComponentFromMonolith
			:params="params"
			:container="Monolith.LAZY_CONTAINER.PROJECT_CALENDAR"
		/>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Monolith } from '@/constants/monolith';
import { AppLazyLoaderComponentFromMonolith } from '@/features/App';
import { useProjectDetailsViewStore } from '@/features/Project';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

const props = defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();

const projectDetailsViewStore = useProjectDetailsViewStore();

const params = computed(() => ({
	retainerPeriodId: props.retainerPeriodId,
	timestamp: projectDetailsViewStore.calendarTimestamp,
	updateCounter: projectDetailsViewStore.calendarUpdateCounter,
	appendCssToHtml: 1,
}));
</script>

<style lang="scss">
.project-calendar {
	.calendar_table {
		.day {
			&:hover {
				.add_event {
					display: inline-block;
				}
			}
		}
	}

	.calendar-close-container-parent {
		display: none;
	}

	.cal-header-wrapper {
		display: flex;
		align-items: center;
		padding: var(--project-tab-header-padding) 0;

		h2 {
			color: $blue-50;
			font-size: 2rem;
			font-weight: $scoro-fw-normal;

			a {
				color: inherit;
			}
		}
	}
}
</style>
